const Application = (id) => `
{
  application(id:"${id}") {
    id
    status
    createdDate
    inactivatedBy
    applicants {
      id
      profilePicture
      index
      image
      started
      email
      documentCategories {
          idProof {
          comment
          ${getDocumentApprovalStatus()}
        }
        incomeBase {
          comment
          ${getDocumentApprovalStatus()}
        }
        rentalAgreement {
          comment
          ${getDocumentApprovalStatus()}
        }
        rentalBase {
          comment
          ${getDocumentApprovalStatus()}
        }
         minUc {
          comment
          ${getDocumentApprovalStatus()}
        }
      }
      application {
        id
      }
      members {
        member1  {
          ${getMember()}
        }
        member2 {
          ${getMember()}
        }
      }
      apartments {
        apartment1 {
          ${getApartment()}
        }
        apartment2 {
         ${getApartment()}
        }
      }
      details {
        swapDate
        details1 {
          ${getDetails()}
        }
        details2 {
          ${getDetails()}
        }
      }
      swapReason  {
        reason
        freeText
        approvalStatus  {
            admin {
              name
              picture
              email
              phone
            }
            date
            type
            message
          }
      }
      documents {
        id
        applicant {
          id
        }
        type
        fileName
        folder
        ${getApprovalStatus()}
        uploadedAt
      }
      bankId {
        ssn
        date
      }
      signed
      reviewed
    }
  }
}
`;

function getApprovalStatus() {
  return `
    approvalStatus {
      admin {
        name
        picture
        email
        phone
      }
      date
      type
      message
    }    
  `;
}

function getDocumentApprovalStatus() {
  return `
    approvalStatus {
      type
      date
    }
  `;
}

function getApartment() {
  return `
    ${getApprovalStatus()}
    address
    apartmentNumber
    area
    city
    hadSince
    landlord 
    landlordAddress
    landlordEmail
    landlordPhone
    objectNumber    
    postalCode
    rent
    rooms    
    childrenCount
    adultCount
  `;
}

function getMember() {
  return `
    ${getApprovalStatus()}
    email
    name
    onCurrentContract
    phone
    registeredAddress
    registeredCity
    registeredPostalCode
    signLink
    ssn
    hasOtherApartment
    otherApartmentInfo
  `;
}

function getDetails() {
  return `
    apartment {      
      ${getApartment()}
    }
    approvalStatus {
      admin {
        name
        picture
        email
        phone
      }
      date
      type
      message
    }
    childrenCount
    freeTextAddress
    moveToApartment
    personCount
  `;
}

export default { Application };



// WEBPACK FOOTER //
// ./src/features/Application/queries.js